import moment from 'moment'
import 'moment/locale/th'

moment.locale('th')

export const formatDateTH = (date = new Date()) => {
  const m = moment(date)

  const buddhistYear = m.year() + 543

  return `${m.format('D MMMM')} ${buddhistYear} เวลา ${m.format('HH:mm:ss')} น.`
}
